// Mock Data in Plain JavaScript (no TypeScript)

// Service Categories
export const serviceCategories = [
  {
    id: "plumbing",
    name: "Plumbing",
    icon: "🔧",
    subcategories: [
      { id: "pipe-repair", name: "Pipe Repair", description: "Fix broken or leaking pipes" },
      { id: "leak-detection", name: "Leak Detection", description: "Find and fix hidden leaks" },
      { id: "drain-cleaning", name: "Drain Cleaning", description: "Unclog drains and sewers" },
      { id: "water-heater", name: "Water Heater", description: "Install or repair water heaters" },
      { id: "emergency-plumbing", name: "Emergency Service", description: "24/7 urgent repairs" },
      { id: "bathroom-fixtures", name: "Bathroom Fixtures", description: "Install sinks, toilets, showers" },
    ],
  },
  {
    id: "electrical",
    name: "Electrical",
    icon: "⚡",
    subcategories: [
      { id: "wiring", name: "Wiring", description: "Install or repair electrical wiring" },
      { id: "lighting", name: "Lighting", description: "Install lights and fixtures" },
      { id: "circuit-repair", name: "Circuit Repair", description: "Fix electrical circuits" },
      { id: "panel-upgrade", name: "Panel Upgrade", description: "Upgrade electrical panels" },
      { id: "emergency-electrical", name: "Emergency Service", description: "24/7 urgent repairs" },
      { id: "outlet-switch", name: "Outlets & Switches", description: "Install or repair outlets" },
    ],
  },
  {
    id: "carpentry",
    name: "Carpentry",
    icon: "🪚",
    subcategories: [
      { id: "furniture-assembly", name: "Furniture Assembly", description: "Assemble furniture" },
      { id: "door-repair", name: "Door Repair", description: "Fix or install doors" },
      { id: "cabinet-install", name: "Cabinet Installation", description: "Install kitchen/bathroom cabinets" },
      { id: "custom-work", name: "Custom Carpentry", description: "Custom woodwork projects" },
      { id: "deck-fence", name: "Deck & Fence", description: "Build or repair decks and fences" },
    ],
  },
  {
    id: "painting",
    name: "Painting",
    icon: "🎨",
    subcategories: [
      { id: "interior-paint", name: "Interior Painting", description: "Paint interior walls" },
      { id: "exterior-paint", name: "Exterior Painting", description: "Paint exterior surfaces" },
      { id: "touch-up", name: "Touch-up", description: "Small painting jobs" },
      { id: "commercial-paint", name: "Commercial Painting", description: "Large commercial projects" },
      { id: "wallpaper", name: "Wallpaper", description: "Install or remove wallpaper" },
    ],
  },
  {
    id: "ac-cooling",
    name: "AC & Cooling",
    icon: "❄️",
    subcategories: [
      { id: "ac-repair", name: "AC Repair", description: "Fix air conditioning units" },
      { id: "ac-maintenance", name: "AC Maintenance", description: "Regular AC servicing" },
      { id: "ac-install", name: "AC Installation", description: "Install new AC units" },
      { id: "duct-clean", name: "Duct Cleaning", description: "Clean air ducts" },
      { id: "emergency-ac", name: "Emergency AC", description: "24/7 urgent AC repairs" },
    ],
  },
  {
    id: "handyman",
    name: "Handyman",
    icon: "🔨",
    subcategories: [
      { id: "general-repair", name: "General Repairs", description: "Various home repairs" },
      { id: "installation", name: "Installation", description: "Install various items" },
      { id: "maintenance", name: "Maintenance", description: "Home maintenance tasks" },
      { id: "assembly", name: "Assembly", description: "Assemble items" },
      { id: "mounting", name: "TV & Mounting", description: "Mount TVs and shelves" },
    ],
  },
  {
    id: "securitySystems",
    icon: "📷",
    name: "Security Systems",
  },
  {
    id: "satelliteTv",
    icon: "📡",
    name: "Satellite & TV",
  },
];

// Taskers
export const taskers = [
  {
    id: "1",
    name: "Ahmed Plumbing",
    rating: 4.8,
    reviews: 120,
    distance: 2.1,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop",
    categories: ["plumbing"],
    subcategories: ["pipe-repair","drain-cleaning","emergency-plumbing"],
    availability: "Today",
    responseTime: "< 15 min",
    priceRange: "150-300 SAR",
    bio: "Professional plumber with 10+ years of experience",
    completedJobs: 450,
  },
  {
    id: "2",
    name: "FastFix Services",
    rating: 4.5,
    reviews: 89,
    distance: 3.5,
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
    categories: ["plumbing", "handyman"],
    subcategories: ["water-heater","leak-detection","general-repair"],
    availability: "Tomorrow",
    responseTime: "< 30 min",
    priceRange: "200-400 SAR",
    bio: "Expert in plumbing and general handyman services",
    completedJobs: 320,
  },
  {
    id: "3",
    name: "Mohammed Electrical",
    rating: 4.9,
    reviews: 156,
    distance: 1.8,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop",
    categories: ["electrical"],
    subcategories: ["wiring","lighting","circuit-repair","emergency-electrical"],
    availability: "Today",
    responseTime: "< 10 min",
    priceRange: "180-350 SAR",
    bio: "Licensed electrician, certified for residential and commercial work",
    completedJobs: 580,
  },
  {
    id: "4",
    name: "Ali Carpenter",
    rating: 4.6,
    reviews: 95,
    distance: 4.2,
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&h=150&fit=crop",
    categories: ["carpentry", "handyman"],
    subcategories: ["furniture-assembly","door-repair","custom-work","mounting"],
    availability: "Today",
    responseTime: "< 20 min",
    priceRange: "160-320 SAR",
    bio: "Skilled carpenter specializing in custom furniture and repairs",
    completedJobs: 280,
  },
  {
    id: "PtazsxqfWVR7wsgeUFNBfrgmzsX2",
    name: "Clean Pro Services",
    rating: 4.7,
    reviews: 203,
    distance: 2.5,
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop",
    categories: ["cleaning"],
    subcategories: ["deep-clean","regular-clean","move-clean","office-clean"],
    availability: "Today",
    responseTime: "< 25 min",
    priceRange: "200-500 SAR",
    bio: "Professional cleaning team with eco-friendly products",
    completedJobs: 620,
  },
  {
    id: "6",
    name: "Cool Air AC",
    rating: 4.8,
    reviews: 142,
    distance: 3.2,
    image: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=150&h=150&fit=crop",
    categories: ["ac-cooling"],
    subcategories: ["ac-repair","ac-maintenance","ac-install","emergency-ac"],
    availability: "Today",
    responseTime: "< 15 min",
    priceRange: "250-600 SAR",
    bio: "AC specialists with 15 years experience in Saudi climate",
    completedJobs: 510,
  },
];

// Tasker Service Offerings
export const taskerServiceOfferings = [
  {
    id: "so1",
    taskerId: "1",
    categoryId: "plumbing",
    subcategoryIds: ["pipe-repair","leak-detection"],
    title: "Expert Pipe Repair & Leak Detection",
    description: "Professional pipe repair and leak detection services. Fast response, quality work guaranteed.",
    priceRange: { min: 150, max: 300 },
    images: ["https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=400"],
    rating: 4.8,
    reviewCount: 45,
  },
  {
    id: "so2",
    taskerId: "3",
    categoryId: "electrical",
    subcategoryIds: ["wiring","lighting"],
    title: "Complete Electrical Solutions",
    description: "Licensed electrician offering wiring, lighting installation, and repairs.",
    priceRange: { min: 180, max: 400 },
    images: ["https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=400"],
    rating: 4.9,
    reviewCount: 62,
  },
  {
    id: "so3",
    taskerId: "5",
    categoryId: "cleaning",
    subcategoryIds: ["deep-clean","regular-clean"],
    title: "Professional Deep Cleaning",
    description: "Thorough cleaning service for homes and offices. Eco-friendly products used.",
    priceRange: { min: 200, max: 500 },
    images: ["https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400"],
    rating: 4.7,
    reviewCount: 89,
  },
];

// Service Requests
export const serviceRequests = [
  {
    id: "sr1",
    customerId: "c1",
    customerName: "Ali Mohammed",
    categoryId: "plumbing",
    subcategoryId: "drain-cleaning",
    title: "Kitchen Sink Clogged",
    description: "Kitchen sink is clogged and draining very slowly. Need urgent help.",
    location: "Al Malaz, Riyadh",
    budget: 200,
    preferredDate: "2026-01-12",
    preferredTime: "14:00",
    status: "open",
  },
  {
    id: "sr2",
    customerId: "c2",
    customerName: "Sara Ahmed",
    categoryId: "electrical",
    subcategoryId: "lighting",
    title: "Install New Lighting",
    description: "Need to install 5 new ceiling lights in living room and bedrooms.",
    location: "Al Olaya, Riyadh",
    budget: 350,
    preferredDate: "2026-01-13",
    preferredTime: "10:00",
    status: "open",
  },
  {
    id: "sr3",
    customerId: "c3",
    customerName: "Khalid Hassan",
    categoryId: "cleaning",
    subcategoryId: "deep-clean",
    title: "Deep Clean 3 Bedroom Apartment",
    description: "Need deep cleaning for entire 3 bedroom apartment before moving in.",
    location: "Al Narjis, Riyadh",
    budget: 450,
    preferredDate: "2026-01-14",
    preferredTime: "09:00",
    status: "assigned",
    taskerId: "5",
    taskerName: "Clean Pro Services",
  },
];

// Jobs
export const jobs = [
  {
    id: "1",
    customerId: "c1",
    customerName: "Ali Mohammed",
    categoryId: "plumbing",
    subcategoryId: "drain-cleaning",
    service: "Drain Cleaning",
    description: "Kitchen sink is clogged and draining slowly",
    location: "3 km away",
    distance: 3,
    date: "2026-01-12",
    time: "14:00",
    price: 180,
    platformFee: 10,
    status: "pending",
  },
  {
    id: "2",
    customerId: "c2",
    customerName: "Sara Ahmed",
    taskerId: "1",
    taskerName: "Ahmed Plumbing",
    categoryId: "plumbing",
    subcategoryId: "pipe-repair",
    service: "Pipe Repair",
    description: "Leaking pipe in bathroom",
    location: "2.1 km away",
    distance: 2.1,
    date: "2026-01-12",
    time: "17:00",
    price: 150,
    platformFee: 10,
    status: "in-progress",
  },
  {
    id: "3",
    customerId: "c3",
    customerName: "Khalid Hassan",
    categoryId: "plumbing",
    subcategoryId: "emergency-plumbing",
    service: "Emergency Repair",
    description: "Burst pipe needs immediate attention",
    location: "1.5 km away",
    distance: 1.5,
    date: "2026-01-11",
    time: "10:00",
    price: 250,
    platformFee: 15,
    status: "pending",
  },
];

// User Reviews
export const userReviews = [
  { id: "1", customerName: "Mohammed Ali", rating: 5, comment: "Fast & professional. Fixed my leak in under an hour!", date: "2026-01-08" },
  { id: "2", customerName: "Fatima Ahmed", rating: 5, comment: "Excellent service. Very knowledgeable and fair pricing.", date: "2026-01-06" },
  { id: "3", customerName: "Abdullah Saeed", rating: 4, comment: "Good work, arrived on time. Recommended!", date: "2026-01-03" },
];

// Tasker Offers
export const taskerOffers = [
  {
    id: "off1",
    requestId: "sr1",
    taskerId: "1",
    taskerName: "Ahmed Plumbing",
    taskerImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop",
    taskerRating: 4.8,
    taskerReviews: 120,
    offeredPrice: 180,
    message: "I can fix your clogged kitchen sink today. I have 10+ years experience and all necessary tools.",
    estimatedDuration: "1-2 hours",
    status: "pending",
    createdAt: "2026-01-11T10:30:00",
  },
  {
    id: "off2",
    requestId: "sr1",
    taskerId: "2",
    taskerName: "FastFix Services",
    taskerImage: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
    taskerRating: 4.5,
    taskerReviews: 89,
    offeredPrice: 200,
    message: "Professional drain cleaning service available today. Quick response guaranteed!",
    estimatedDuration: "1 hour",
    status: "pending",
    createdAt: "2026-01-11T11:15:00",
  },
  {
    id: "off3",
    requestId: "sr2",
    taskerId: "3",
    taskerName: "Mohammed Electrical",
    taskerImage: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop",
    taskerRating: 4.9,
    taskerReviews: 156,
    offeredPrice: 320,
    message: "Licensed electrician ready to install your ceiling lights tomorrow. All materials included.",
    estimatedDuration: "3-4 hours",
    status: "pending",
    createdAt: "2026-01-11T09:45:00",
  },
  {
    id: "off4",
    requestId: "sr2",
    taskerId: "2",
    taskerName: "FastFix Services",
    taskerImage: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
    taskerRating: 4.5,
    taskerReviews: 89,
    offeredPrice: 350,
    message: "We can handle the lighting installation tomorrow morning. Professional team with 5-year warranty.",
    estimatedDuration: "3 hours",
    status: "pending",
    createdAt: "2026-01-11T12:00:00",
  },
];
